import { reactive } from 'vue';
import { AuthService } from './AuthService';

export const authService = reactive(new AuthService())
